import { parseParams } from "./channels"
import Sortable from "sortablejs"

import { initializeEngagmentSlider } from "./helpers";

$(document).on('turbolinks:load', function() {
  $('#new_narrative_form').submit(function(e) {
    e.preventDefault();
    $('#narrative-form').modal('hide');

    $.ajax({
      type: "POST",
      url: "/narratives",
      data: {
        narrative: { 
          title: $('#narrative_title').val(), 
          network_id: $('#narrative_network_id').val()
        },
        ajax_form: true
      },
      success: (response) => {
        console.log(response)
      },
      error: function(response) {
        console.log('Something went wrong. Please try again.');
      }
      
    });
  });

  $('form#narrative-save-search-form').submit(function(e) {
    $('#save-search-query-field').val(JSON.stringify(parseParams(window.location.search)));
  });

  var issues_list = $("#issue-list-sortable")
  if (issues_list.length > 0){
    new Sortable($("#issue-list-sortable")[0], {
      group: 'nested', // set both lists to same group
      animation: 150
    });
  }

  var narrtives_list = $("#narratives-list-sortable");
  if(narrtives_list.length > 0){
    new Sortable($("#narratives-list-sortable")[0], {
      group: 'shared', // set both lists to same group
      animation: 150
    });
  }

  initializeNestedNarrativeList();

  initializeEngagmentSlider("#narrative-eng-slider", false);

});

export function initializeNestedNarrativeList(){
  var nestedSortables = $(".narrative-nested-sortable");
  if(nestedSortables.length > 0){
    for (var element of nestedSortables) {
      new Sortable(element, {
        group: 'nested',
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        dragoverBubble: true,

        onAdd: function (evt) {
          
          var to_id = $(evt.to).attr("id")
          var issue_id = $(evt.item).attr("id")

          $(evt.to).find(".placeholder-div").remove();

          $.ajax({
            type: "POST",
            url: `/narratives/${to_id}/add_issue`,
            data: {
              issue_id: issue_id
            },
            success: (response) => {
              $("#narrative_issues_count-" + to_id).text(response["issues_count"] + " Issues")
            },
            error: function(response) {
              console.log('Something went wrong. Please try again.');
            }
            
          });
        },
        onRemove: function (evt) {
          var from_id = $(evt.from).attr("id")
          var issue_id = $(evt.item).attr("id")

          if ($(evt.from).find(".my-handle").length == 0){
            $(evt.from).html('<div class="d-flex justify-content-center placeholder-div text-secondary"> Drag here to add issues to this narrative</div>')
          }

          $.ajax({
            type: "POST",
            url: `/narratives/${from_id}/remove_issue`,
            data: {
              issue_id: issue_id
            },
            success: (response) => {
              $("#narrative_issues_count-" + from_id).text(response["issues_count"] + " Issues")
            },
            error: function(response) {
              console.log('Something went wrong. Please try again.');
            }
            
          });
        }
      });
    }
  }
}